'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapper = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Input = require('./Input');

var _Input2 = _interopRequireDefault(_Input);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*********
* MAPPER *
**********/
var mapGmapToApi = function mapGmapToApi(data) {

  var findComponent = function findComponent(address, type) {
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "short_name";

    if (!address) return '';

    var obj = address.find(function (a) {
      return a.types.indexOf(type) > -1;
    });
    if (obj) return obj[key] || '';

    return '';
  };

  return data ? {
    g_street_number: findComponent(data.address_components, 'street_number'),
    g_street: findComponent(data.address_components, 'route'),
    g_city: findComponent(data.address_components, 'locality'),
    g_state: findComponent(data.address_components, 'administrative_area_level_1'),
    g_zip_code: findComponent(data.address_components, 'postal_code'),
    g_country: findComponent(data.address_components, 'country', 'long_name'),
    g_country_code: findComponent(data.address_components, 'country'),
    g_geometry_location: data.geometry && data.geometry.location ? {
      lat: data.geometry.location.lat(),
      lng: data.geometry.location.lng()
    } : null,
    g_place_id: data.place_id || '',
    g_formatted_address: data.formatted_address
  } : {};
};

var mapper = exports.mapper = {
  fromApi: function fromApi(_ref) {
    var gmaps = _ref.gmaps;
    return {
      placeSearched: gmaps ? gmaps.g_formatted_address || '' : ''
    };
  },
  toApi: function toApi(gmap) {
    return !gmap ? {} : mapGmapToApi(gmap);
  }

  /*****************
   * SCRIPT LOADER *
   *****************/

};var loadScript = function loadScript(url) {
  return new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.async = true;
    script.addEventListener('load', function () {
      return resolve(script);
    });
    script.addEventListener('error', function () {
      return reject(script);
    });
    document.body.appendChild(script);
  });
};

/*************
 * COMPONENT *
 *************/

var InputGmap = function (_PureComponent) {
  _inherits(InputGmap, _PureComponent);

  function InputGmap() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, InputGmap);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = InputGmap.__proto__ || Object.getPrototypeOf(InputGmap)).call.apply(_ref2, [this].concat(args))), _this), _this.keyActive = -1, _this.service = null, _this.autocompleteService = null, _this.state = {
      displayPredictions: false,
      predictions: []
    }, _this.getInfoOnLocation = function (placeId, placeName) {

      if (!_this.service) {
        _this.service = new window.google.maps.places.PlacesService(document.createElement('div'));
      }

      var onChange = _this.props.onChange;

      _this.service.getDetails({
        placeId: placeId
      }, function (place) {
        onChange({ placeSearched: placeName, infoLocation: place, mapped: mapper.toApi(place) });
      });
    }, _this.onChange = function (_ref3) {
      var newValue = _ref3.value;
      var onChange = _this.props.onChange;

      if (!newValue || newValue === '') {
        _this.setState({ displayPredictions: false, predictions: [] });
      } else {
        if (!_this.state.displayPredictions) _this.setState({ displayPredictions: true });
      }
      onChange({ placeSearched: newValue, infoLocation: [], mapped: {} });

      if (_this.delayType) {
        clearTimeout(_this.delayType);
        _this.delayType = null;
      }

      _this.delayType = setTimeout(_this.triggerAutoComplete(newValue), 300);
    }, _this.triggerAutoComplete = function (value) {
      return function () {

        if (!window.google || !value) return;

        var google = window.google;
        if (!_this.autocompleteService) _this.autocompleteService = new google.maps.places.AutocompleteService();
        var extraProperties = _this.props.extraProperties;

        _this.autocompleteService.getPlacePredictions(_extends({ input: value }, extraProperties), function (prediction, status) {
          var predictions = [];
          var selectedId = void 0;

          if (status === 'OK') {
            predictions = prediction;
            _this.setState({ predictions: predictions });
          }

          var index = predictions.findIndex(function (element) {
            return element.description.toLowerCase() === value.trim().toLowerCase();
          });

          selectedId = index !== -1 ? predictions[index].place_id : null;

          if (selectedId !== null) _this.getInfoOnLocation(selectedId, value);
        });
      };
    }, _this.onKeyPress = function (_ref4) {
      var key = _ref4.keyCode;


      if (_this.state.predictions.length === 0 || key !== 38 && key !== 40) return;
      if (key === 38) _this.keyActive -= 1;
      if (key === 40) _this.keyActive += 1;
      if (_this.keyActive >= _this.state.predictions.length) _this.keyActive = 0;
      if (_this.keyActive < 0) _this.keyActive = _this.state.predictions.length - 1;

      var selectedId = _this.state.predictions[_this.keyActive].place_id;
      var newValue = _this.state.predictions[_this.keyActive].description;
      _this.getInfoOnLocation(selectedId, newValue);

      _this.setState({ displayPredictions: true });
    }, _this.componentDidMount = function () {
      var GmapApiKey = _this.props.GmapApiKey;

      if (!window.scriptLoading) {
        window.scriptLoading = true;
        loadScript('https://maps.googleapis.com/maps/api/js?key=' + GmapApiKey + '&libraries=places');
      }
    }, _this.selectItemFromList = function (index) {
      return function () {
        var target = _this.state.predictions[index];
        var newValue = target.description;
        var selectedId = target.place_id;
        _this.getInfoOnLocation(selectedId, newValue);
        _this.keyActive = index;
        _this.setState({ displayPredictions: false });
      };
    }, _this.onFocus = function () {
      _this.setState({ displayPredictions: true });
    }, _this.onBlur = function () {
      setTimeout(function () {
        return _this.setState({ displayPredictions: false });
      }, 200);
    }, _this.onEnter = function () {
      _this.setState({ displayPredictions: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InputGmap, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          placeholder = _props.placeholder,
          label = _props.label,
          disabled = _props.disabled;
      var placeSearched = this.props.value.placeSearched;
      var _state = this.state,
          displayPredictions = _state.displayPredictions,
          predictions = _state.predictions;

      return _react2.default.createElement(
        'div',
        { className: 'bnc_field_input_gmap' },
        _react2.default.createElement(_Input2.default, {
          value: placeSearched,
          onChange: this.onChange,
          onKeyPress: this.onKeyPress,
          placeholder: placeholder,
          label: label,
          onFocus: this.onFocus,
          onBlur: this.onBlur,
          onEnterPress: this.onEnter,
          disabled: disabled
        }),
        displayPredictions && predictions.length > 0 && _react2.default.createElement(
          'div',
          { className: 'bnc_field_input_gmap_predictions' },
          _react2.default.createElement(
            'ul',
            null,
            predictions.map(function (prediction, index) {
              return _react2.default.createElement(
                'li',
                { key: index },
                _react2.default.createElement(
                  'button',
                  {
                    className: _this2.keyActive === index ? 'active' : null,
                    onClick: _this2.selectItemFromList(index)
                  },
                  prediction.description
                )
              );
            })
          )
        )
      );
    }
  }]);

  return InputGmap;
}(_react.PureComponent);

InputGmap.defaultProps = {
  label: '',
  placeholder: '',
  disabled: false,
  extraProperties: {}
};

InputGmap.propTypes = {
  label: _utils.StringOrReact,
  placeholder: _propTypes2.default.string,
  GmapApiKey: _propTypes2.default.string.isRequired,
  disabled: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  extraProperties: _propTypes2.default.shape({
    types: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(["geocode", "address", "regions", "cities", "locality", "sublocality", "postal_code", "country", "administrative_area_level_1", "administrative_area_level_2", "administrative_area_level_3"])),
    radius: _propTypes2.default.number,
    offset: _propTypes2.default.number,
    location: _propTypes2.default.shape({
      lat: _propTypes2.default.number,
      lng: _propTypes2.default.number,
      noWrap: _propTypes2.default.bool
    })
  })
};

exports.default = InputGmap;